<cec-dialog
  #dialog
  headerKey="Sign in"
  [subTitle]="seasonName()"
  [formGroup]="formGroup"
  [disableConfirmButton]="formGroup.invalid"
  (onButtonClicked)="onClickButton($event)"
>
    <form [formGroup]="formGroup">
        <div class="row">
          <cec-select labelKey="Crew number" [options]="crews" formControlName="crewId"></cec-select>
        </div>
        <div class="row">
          <cec-select labelKey="Driver" [options]="competitors" formControlName="driverId"></cec-select>
          <cec-select labelKey="Navigator" [options]="competitors" formControlName="navigatorId"></cec-select>
        </div>
    </form>
</cec-dialog>